import { Config, CognitoIdentityCredentials } from 'aws-sdk'
import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser,
} from 'amazon-cognito-identity-js'

const config = new Config({
  region: process.env.REACT_APP_AWS_REGION,
  credentials: new CognitoIdentityCredentials({
    IdentityPoolId: process.env
      .REACT_APP_AWS_IDENTITY_POOL_ID as AWS.CognitoIdentity.IdentityPoolId,
  }),
})

const authenticationDetail = (username: string, password: string) => {
  return new AuthenticationDetails({
    Username: username,
    Password: password,
  })
}

const userPool = () => {
  return new CognitoUserPool({
    UserPoolId: String(process.env.REACT_APP_AWS_USER_POOL_ID),
    ClientId: String(process.env.REACT_APP_AWS_USER_CLIENT_ID),
  })
}

const cognitoUser = (username: string) => {
  return new CognitoUser({
    Username: username,
    Pool: userPool(),
  })
}

const cognitoIdpURL =
  'cognito-idp.' +
  process.env.REACT_APP_AWS_REGION +
  '.amazonaws.com/' +
  process.env.REACT_APP_AWS_USER_POOL_ID

export { config, userPool, cognitoUser, authenticationDetail, cognitoIdpURL }



// WEBPACK FOOTER //
// ./src/constants/aws.constant.ts